<h2 mat-dialog-title> {{ data.enabling? 'Abilita' : 'Disabilita' }} Utente</h2>
<hr>
<mat-dialog-content class="container" id="enable-disable-user-container">
    <p>{{ data.enabling? 'Abilitare' : 'Disabilitare' }} l'utente <i>{{ data.user.username }}</i></p>
</mat-dialog-content>
<hr>
<mat-dialog-actions id="action-div">
    <button mat-stroked-button (click)="closeCancelling()" type="button">Annulla</button>
    <button mat-stroked-button color="primary" (click)="closeConfirming()">{{ data.enabling? 'Abilita' : 'Disabilita' }}</button>
</mat-dialog-actions>